import {
  useMantineTheme,
  useComputedColorScheme,
  Paper,
  Stack,
  Group,
  Divider,
  ScrollArea,
  Text,
} from '@mantine/core';
import { Chain, formatTypeLabel } from './ViewClaimActionsModal';
import { ChainListItem } from './ChainListItem';
import { ActionRequestStatus, ActionRequestType } from '@billing/validation';

export const ChainSidebar = ({
  chains,
  selectedRootID,
  onSelect,
  statusColor,
  typeColor,
}: {
  chains: Chain[];
  selectedRootID: string | null;
  onSelect: (id: string) => void;
  statusColor: Record<ActionRequestStatus, string>;
  typeColor: Record<ActionRequestType, string>;
}) => {
  const theme = useMantineTheme();
  const mode = useComputedColorScheme();

  return (
    <Paper
      radius="lg"
      withBorder
      p="sm"
      data-testid="chain-sidebar"
      style={{
        width: 300,
        background:
          mode === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
      }}
    >
      <Stack gap="xs">
        <Group justify="space-between" align="center">
          <Text fw={700} size="sm" data-testid="chain-sidebar-title">
            {'Requests'}
          </Text>
          <Text size="xs" c="dimmed" data-testid="chain-sidebar-count">
            {chains.length}
          </Text>
        </Group>
        <Divider />
        <ScrollArea h={460} type="auto">
          <Stack gap="xs">
            {chains.map((chain) => (
              <ChainListItem
                key={chain.root.id}
                chain={chain}
                selected={chain.root.id === selectedRootID}
                onClick={() => onSelect(chain.root.id)}
                statusColor={statusColor}
                typeColor={typeColor}
                typeLabel={formatTypeLabel(chain.root.type)}
                testID={`chain-list-item-${chain.root.id}`}
              />
            ))}
          </Stack>
        </ScrollArea>
      </Stack>
    </Paper>
  );
};
